import { IGetItemsParams } from '~src/httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '~src/httpClient/serverApi/types/IGetItemsResult';
import { IPredictiveModel } from '~src/predictiveModel/serverApi/types/IPredictiveModel';
import { ITypedItem } from '~src/spacesPlatform/models/resourceParts';
import { IUser } from '~src/userManagement/users/serverApi/types/IUser';

import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IGetPredictiveModelsParams extends IGetItemsParams {
}

export interface IGetPredictiveModelsResult extends IGetItemsResult {
  predictiveModels?: IPredictiveModel[];
  users?: IUser[];
  containers?: ITypedItem[];
  favorites?: string[];
}

export class GetPredictiveModelsRequest extends Request<IGetPredictiveModelsParams, IGetPredictiveModelsResult> {
  constructor(params: IGetPredictiveModelsParams) {
    super('getPredictiveModels', params);
  }
}
